import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const MtFormButtonsContainer = styled.div<{ sticky: boolean }>`
  ${(props) =>
    props.sticky &&
    `
    position: sticky;
    z-index: 1;
    bottom: 0;
    left: 0;
    width: 100%;
    align-items: center;
    justify-content: center;
    align-content: center;

    ${mediaQuery('phone')} {
      display: flex;
    }`}
`;
